// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"597b5e74","498":"4d6df52b","562":"424703b8"}[chunkId] + ".chunk.css";
};